import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { ServicePeopleSvg } from './ServicePeopleSvg'

export const EaServicePeopleIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={ServicePeopleSvg} {...props} />
)
